// For now this timeline is the same as execution
import createExecutionLine from '@/assets/js/hero/execution'

const createLoveLine = createExecutionLine
export default createLoveLine



// WEBPACK FOOTER //
// ./src/assets/js/hero/love.js